import { render } from "./ModalObservar.vue?vue&type=template&id=1e491618&scoped=true"
import script from "./ModalObservar.vue?vue&type=script&lang=js"
export * from "./ModalObservar.vue?vue&type=script&lang=js"

import "./ModalObservar.vue?vue&type=style&index=0&id=1e491618&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e491618"]])

export default __exports__